<section class="page-header">
  <div class="title-container">
    <h1>{{ "translate.mng.mngEnv" | translate }}</h1>
  </div>
</section>

<div class="header-actions">
  <button class="t-button-outline" (click)="addEnv()">
    {{ "translate.mng.addEnv" | translate }}
  </button>
</div>

<loader *ngIf="!envList || envList.loading"></loader>

<ui-table
  [isWrapped]="false"
  [data]="envList"
  [numberOfRows]="10"
  [displayFilter]="['id', 'descr']"
  [templates]="[
    {
      title: 'translate.general.actions',
      template: actions
    }
  ]"
></ui-table>

<ng-template #actions let-row="row">
  <a (click)="editEnv(row)">{{ "translate.general.edit" | translate }}</a>
  <span class="action-divider">|</span>
  <a (click)="onConfigureIntegration(row)">{{ "translate.cat.configureIntegration" | translate }}</a>
  <span class="action-divider">|</span>
  <a (click)="onConfigureProcessing(row)">{{"translate.general.configureProcessing" | translate }}</a>   
  <span class="action-divider">|</span>
  <a (click)="onConfigureUi(row)">{{"translate.general.configureUi" | translate }}</a>
</ng-template>

<p-dialog
  [(visible)]="displayJsonDialog"
  [modal]="true"
  [closable]="true"
  [resizable]="true"
  (onHide)="onDialogHide()"
  [style]="{ width: '900px', height: '600px' }"
>

  <p-panel
  header="Processing configuration parameters"
  [style]="{ width: '100%' }"
>
  <div class="filters-container">

    <div class="filters-row">
      <input-wrap
        [loading]="langList && langList.loading"
        label="{{ 'translate.general.lang' | translate }}"
        cssClass="l-cell-spread"
      >
        <p-select
          [options]="langList"
          optionLabel="label"
          optionValue="id"
          [(ngModel)]="filterLanguage"
          (onChange)="onLanguageValueChanged($event)"
          class="l-cell-spread-x"
          [resetFilterOnHide]="true"
          [disabled]="filterStatus || filterAssetType || filterCountry"
          [filterPlaceholder]="'translate.general.search' | translate"
          showClear="true"
          [placeholder]="'translate.general.select' | translate"
          [filter]="true"
          appendTo="body"
          baseZIndex="100"
        >
        </p-select>
      </input-wrap>

      <input-wrap
        [loading]="assetTypeList?.loading"
        label="{{ 'translate.general.assetType' | translate }}"
      >
        <p-select
          [options]="assetTypeList"
          optionLabel="label"
          optionValue="id"
          showClear="true"
          [(ngModel)]="filterAssetType"
          [disabled]="filterStatus || filterLanguage || filterCountry"
          [resetFilterOnHide]="true"
          [filterPlaceholder]="'translate.general.search' | translate"
          [placeholder]="'translate.general.select' | translate"
          [filter]="true"
          (onChange)="onAssetTypeChanged($event)"
        >
        </p-select>
      </input-wrap>
    </div>

    <!-- DRUGI RED -->
    <div class="filters-row">
      <input-wrap
        [loading]="statusList && statusList.loading"
        label="{{ 'translate.general.runType' | translate }}"
      >
        <p-select
          [options]="statusList"
          optionLabel="label"
          optionValue="value"
          showClear="true"
          [(ngModel)]="filterStatus"
          [disabled]="filterAssetType || filterLanguage || filterCountry"
          [resetFilterOnHide]="true"
          [placeholder]="'translate.general.select' | translate"
          [filter]="true"
          (onChange)="onFieldValueChanged($event)"
        >
        </p-select>
      </input-wrap>

      <input-wrap
        [loading]="countryList?.loading"
        label="{{ 'translate.general.country' | translate }}"
      >
        <p-select
          [options]="countryList"
          optionLabel="label"
          optionValue="id"
          showClear="true"
          [(ngModel)]="filterCountry"
          [resetFilterOnHide]="true"
          [disabled]="filterStatus || filterLanguage || filterAssetType"
          [filterPlaceholder]="'translate.general.search' | translate"
          [placeholder]="'translate.general.select' | translate"
          [filter]="true"
          (onChange)="onCountryChanged($event)"
        >
        </p-select>
      </input-wrap>
    </div>

  </div>
</p-panel>

<app-json-editor
  [jsonData]="jsonDialogData"
  [jsonReadOnlyData]="jsonReadOnlyData"
  [readonlyPanelLabel]="'translate.general.effectiveConfiguration'"
  [editablePanelLabel]="'translate.general.customConfiguration'"
  (jsonSave)="handleJsonSave($event)"
  (jsonCancel)="handleJsonCancel()"
>
</app-json-editor>
</p-dialog>

<p-dialog
  [(visible)]="displayUiConfigDialog"
  [modal]="true"
  [closable]="true"
  [resizable]="true"
  [style]="{ width: '900px', height: '600px' }"
>
  <app-json-editor
    [jsonData]="envSpecificUiConfig"
    [jsonReadOnlyData]="envEffectiveUiConfig"
    [readonlyPanelLabel]="'translate.general.envEffectiveUiConfig'"
    [editablePanelLabel]="'translate.general.envSpecificUiConfig'"
    (jsonSave)="handleUiConfigSave($event)"
    (jsonCancel)="displayUiConfigDialog = false"
  >
  </app-json-editor>

</p-dialog>

<edit-env
  *ngIf="editEnvOpenSw"
  [env]="curEnv"
  (onClose)="editEnvOpenSw = false"
  (onSave)="editEnvOpenSw = false; refreshEnvList()"
>
</edit-env>

<scai-configure-integration
  *ngIf="displayConfigureIntegration"
  (closeDialog)="displayConfigureIntegration = false"
  [configScope]="integrationConfigurationScope"
  [environmentId]="curEnv.id"
  (configuredIntegration)="onIntegrationConfigured($event)"
></scai-configure-integration>